import React, { useContext } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { CompRating } from '../../pages/About/About'
import './basicCard.css'

const BasicCard = ({ children }) => {
  const [icon, language] = useContext(CompRating)
  const styleCard = {
    background: '#ecf0f3',
    boxShadow: 'inset 6px 6px 6px 0 #cbced1,inset -6px -6px 6px 0 white',
    borderRadius: '40px',
    padding:'10px',
    marginBottom:'5px'
  }
 
  return (
    <Card sx={styleCard}>
      <CardContent>
        <div className='card-icon'>
          <img src={icon} alt='stack icon' />
        </div>
        <h5 className='stack-title'>{language}</h5>
        {children}
      </CardContent>
    </Card>
  )
}

export default BasicCard
